import { useEffect } from 'react';
import { PULSE_VIEW_ID, trackPulseView } from './pulseViewIds';

/** Pulse `view` when reCAPTCHA is shown (login, forgot password, guest checkout). */
export function usePulseRecaptchaView(
  enabled: boolean,
  pagePath?: string
): void {
  useEffect(() => {
    if (!enabled) return;
    trackPulseView(PULSE_VIEW_ID.RECAPTCHA_VERIFICATION, {
      page_path:
        pagePath ??
        (typeof window !== 'undefined' ? window.location.pathname : undefined),
    });
  }, [enabled, pagePath]);
}
